<template>
  <b-card
    bg-variant="green-darken-2"
    text-variant="white"
    class="rounded-lg text-white"
  >
    <template v-if="loaded && currentPlan.length > 0">
      <b-card-title class="text-white">
        {{ $t("BillingPageCard.rightSide.title") }}
      </b-card-title>

      <b-card-text
        v-for="(data, index) in currentPlan"
        :key="index"
      >
        <p class="font-weight-bold">
          {{ data.plan_name }}
        </p>
        <p>
          {{
            $t("BillingPageCard.invoiceNumber", {
              number: data.invoiceNumbers,
            })
          }}
        </p>
        <p class="ml-2">
          {{ data.price }} sek / {{ $t("Message.month") }}
        </p>
      </b-card-text>

      <b-link
        :to="{ name: 'subscription' }"
        class=""
      >
        {{ $t("BillingPageCard.rightSide.planLink") }} >>
      </b-link>
    </template>

    <Loading v-if="!loaded" />
  </b-card>
</template>

<script>
import { getSubscribersMixins } from '@/mixins/getSubscribersMixins'

export default {
  name: 'CurrentPlan',
  mixins: [getSubscribersMixins],
  data() {
    return {
      currentPlan: [],
      loaded: false,
    }
  },

  mounted() {
    this.renderCurrentPlan()
  },

  methods: {
    async renderCurrentPlan() {
      this.loaded = false
      try {
        let currentPlanId = []
        try {
          currentPlanId = await this.getCurrentPlan()
        } catch (e) {
          currentPlanId = []
        }
        let paymentPlan = []
        try {
          paymentPlan = await this.getPaymentPlan()
        } catch (e) {
          paymentPlan = []
        }

        this.$useJwt
          .packages()
          .then(res => {
            const results = res && res.data && Array.isArray(res.data.results)
              ? res.data.results
              : []

            const getCurrentPlan = results.filter(element => {
              if (element.package !== null) {
                return (
                  element.package.id == (currentPlanId && currentPlanId[0])
                )
              }
            })

            getCurrentPlan.forEach(element => {
              this.currentPlan.push({
                plan_name: element.package.package_name,
                price:
                  (paymentPlan && paymentPlan[0]) === 'Quarterly'
                    ? element.quarterly_base_price_monthly_average
                    : element.yearly_base_price_monthly_average,
                invoiceNumbers: element.number_of_invoices_per_month,
                paymentPlan: paymentPlan[0],
              })
            })
          })
          .catch(() => {
            this.currentPlan = []
          })
          .finally(() => {
            this.loaded = true
          })
      } catch (e) {
        this.loaded = true
      }
    },
  },
}
</script>

<style></style>
